import parserUtils from './utils'
import { toNumber, get } from 'lodash'

export default {
    parseData: (type, data) => {
        const _data = []
        for (const val of data) {
            const wamData = {
                id: toNumber(val.id),
                category: get(val, 'custom_category', null),
                label: val.label,
                isSelectable: true,
                display_order: toNumber(val.display_order),
                hasChild: parserUtils.findChild(data, val.id),
                parentJsonKeyName: parserUtils.getParentJsonKeyName(get(val, 'parent_wam_custom_segment_id', null), val),
                identifier: toNumber(get(val, 'custom_identifier', null)),
                smartSegmentIds: parserUtils.getSmartSegmentIds(get(val, 'smart_segments', null)),
                jsonKey: {
                    name: 'custom_segment_' + val.id,
                    type: 'CustomSegment',
                    subType: type,
                    ids: [toNumber(val.id)]
                }
            }
            _data.push(wamData)
        }
        return _data.sort((a, b) => (a.display_order > b.display_order ? 1 : b.display_order > a.display_order ? -1 : 0))
    }
}
